import React, { useContext, useEffect, useState } from "react";
import api from "../../services/api";
import AppContext from "../../container/context";
import Form from "../../components/form";
import { 
  CircularProgress,
  Button,
  Card,
  CardActionArea,
  CardContent,
  CardMedia,
  Grid,
  MenuItem,
  Select,
  TextField,
} from "@mui/material";
import ActionTable from "../../components/table/ActionTable";
import materialProduto from "../../enums/materialProduto";
import { makeStyles } from "@mui/styles";
import AuthContext from "../../auth/context";
//import serverHost from "../../services/serverHost";

const serverHost = () => 'https://pertobilingueadm.com.br/pews';

export default function Catalogo(props) {
  const { usuario } = useContext(AuthContext);
  const { notification } = useContext(AppContext);
  const [escolaId] = useState(Number(props.match.params.escolaId));  
  const [carregando, setCarregando] = useState(false);
  const [escolas, setEscolas] = useState([]);
  const [escola, setEscola] = useState({});
  const [filtros, setFiltros] = useState({});
  const [produtoSelecionado, setProdutoSelecionado] = useState({});
  const [produtoCategorias, setProdutoCategorias] = useState([]);
  const [catalogo, setCatalogo] = useState([]);
  const history = props.history;
  const classes = useStyles();

  useEffect(() => {
    if(escolaId){
      carregarEscola();
    } else {
      listarEscolas();
    }
    
    listarProdutoCategorias();
  }, []);

  const carregarEscola = () => {
    setCarregando(true);
    api
      .get("escolas/carregar", {id: escolaId})
      .then(escola => {
        setEscola(escola);
        carregarCatalogo({...filtros, escolaId: escola.id});
        setCarregando(false);
      })
      .catch((e) => {
        console.log(e);
        notification("warning", "Erro ao carregar escola")
      });
  };

  const listarEscolas = () => {
    setCarregando(true);
    api
      .get("escolas/listar")
      .then((escolas) => {
        setEscolas(escolas);
        setCarregando(false);
      })
      .catch((e) => {
        console.log(e);
        notification("warning", "Erro ao listar escolas")
      });
  };

  const carregarCatalogo = (filtros) => {
    const paramCatalogo = {
      escolaId: filtros.escolaId,
    };

    if (filtros.nome) {
      paramCatalogo.nome = filtros.nome;
    }
    if (filtros.categoriaId) {
      paramCatalogo.categoriaId = filtros.categoriaId;
    }
    if (filtros.produtoPerto) {
      paramCatalogo.produtoPerto = filtros.produtoPerto;
    }

    setFiltros(paramCatalogo);
    setCarregando(true);
    api
      .get("produtos/catalogoEscola", paramCatalogo)
      .then((catalogo) => {
        catalogo.forEach((c) => (c.valor = `R$  ${c.valorVenda / 100} `));
        setCatalogo(catalogo);
        setCarregando(false);
      })
      .catch((e) => notification("warning", "Erro ao carregar catalogo"));
  };

  const listarProdutoCategorias = () => {
    api
      .get("produtos/listarCategorias")
      .then((produtoCategorias) => {
        setProdutoCategorias(produtoCategorias);
      })
      .catch((err) => {
        console.log(err);
        notification("warning", "Erro ao listar as categorias de produtos.");
      });
  };

  const selecionarEscola = (form) => {
    escolas
      .filter((e) => e.id === Number(form.escolaId))
      .forEach((e) => {
        setEscola(e);
        carregarCatalogo({...filtros, escolaId: e.id});
      });
  };

  const fSelecaoEscola = {
    form: escola.id
      ? {
          escolaProfissional: {
            label: "Componente",
            type: "component",
            // space: 6,
            value: (
              <div>
                <h4>Escola</h4>
                <p>{escola.nomeFantasia}</p>
              </div>
            ),
          },
        }
      : {
          escolaId: {
            label: "Escola",
            type: "select",
            value: escola.id,
            array: {
              data: escolas,
              value: "id",
              desc: "nomeFantasia",
            },
            emptyItem: true,
            emptyItemText: "(Selecione)",
            emptyItemValue: 0,
          },
        },
    title: "Catálogo da escola",
    history,
    submit: escola.id
      ? undefined
      : {
          label: "Confirmar",
          action: selecionarEscola,
        },
    close: { label: "Fechar" },
    customActions: escola.id ? [
      {
        label: "Ir para o carrinho",
        action: () => history.push(`/app/quinzenas-carrinhos/carrinho/${usuario.usuarioId}/${escola.id}`)
      }
    ] : [],
    // customActions: escola.id && !escolaId
    //   ? [
    //       {
    //         label: "Alterar",
    //         action: () => setEscola({}),
    //       },
    //     ]
    //   : undefined,
  };

  const camposFiltros = () => {
    return {
      nome: {
        label: "Nome",
        type: "text",
        value: filtros.nome,
        space: 6,
      },
      categoriaId: {
        label: "Categoria",
        type: "select",
        emptyItem: true,
        array: {
          data: produtoCategorias,
          value: "id",
          desc: "nome",
        },
        value: filtros.produtoCategoriaId,
        space: 3,
      },

      produtoPerto: {
        label: "Produto Perto",
        type: "select",
        emptyItem: true,
        space: 3,
        options: [
          {
            value: 1,
            desc: "Bilíngue",
          },
          {
            value: 2,
            desc: "Uni Dune Tê",
          },
        ],
        value: filtros.produtoPerto,
      },
    };
  };

  const fFiltro = {
    form: camposFiltros(),
    title: "Buscar produto",
    submit: {
      label: "Buscar",
      action: carregarCatalogo,
    },
  };

  const adicionarProdutoCarrinho = (form) => {
    if (!form.quantidade || form.quantidade < 1)
      return notification("warning", "Quantidade inválida");

    const item = {
      produtoId: produtoSelecionado.id,
      valor: produtoSelecionado.valorVenda * 100,
      quantidade: form.quantidade,
      escolaId: escola.id
    };

    api
      .post("carrinhos/inserirItem", item)
      .then((res) => {
        notification("success", "Carrinho atualizado");
        carregarCatalogo({...filtros, escolaId: escola.id});
        //history.goBack();

        setProdutoSelecionado({});
      })
      .catch((err) => {
        const { data } = err;
        switch (data[0]) {
          case 1:
            return notification("error", "Usuário inválido");
          case 2:
            return notification("error", "Quantidade inválida");
          case 3:
            return notification("error", "Valor inválido");
          case 4:
            return notification("error", "Produto inválido");
          case 5:
            return notification(
              "error",
              "Produto com venda exclusiva para outra(s) escola(s)"
            );
          default:
            return notification("error", "Dados inválidos");
        }
      });
  };

  const fProdutoSelecionado = {
    title: "Produto",
    form: {
      imagem: {
        type: 'component',
        value: (
          <Card style={{ margin: "15px" }}>
            <CardMedia
              className={classes.media}
              image={
                produtoSelecionado.imagemPrincipal
                  ? `${serverHost()}/${produtoSelecionado.imagemPrincipal}`
                  : ""
              }
              title="Contemplative Reptile"
            />
          </Card>
        )
      },
      nome: {
        label: "Componente",
        type: "component",
        space: 4,
        value: (
          <div>
            <h4>Produto</h4>
            <p>{produtoSelecionado.nome}</p>
          </div>
        ),
      },
      categoria: {
        label: "Componente",
        type: "component",
        space: 4,
        value: (
          <div>
            <h4>Categoria</h4>
            <p>{produtoSelecionado.categoriaNome}</p>
          </div>
        ),
      },

      valor: {
        label: "Componente",
        type: "component",
        space: 4,
        value: (
          <div>
            <h4>Valor</h4>
            <p>{produtoSelecionado.valor}</p>
          </div>
        ),
      },

      descricao: {
        label: "Componente",
        type: "component",
        // space: 4,
        value: (
          <div>
            <h4>Descrição</h4>
            <p>{produtoSelecionado.descricao}</p>
          </div>
        ),
      },

      altura: {
        label: "Componente",
        type: "component",
        space: 4,
        value: (
          <div>
            <h4>Altura (cm)</h4>
            <p>{produtoSelecionado.altura}</p>
          </div>
        ),
      },

      largura: {
        label: "Componente",
        type: "component",
        space: 4,
        value: (
          <div>
            <h4>Largura (cm)</h4>
            <p>{produtoSelecionado.largura}</p>
          </div>
        ),
      },
      peso: {
        label: "Componente",
        type: "component",
        space: 4,
        value: (
          <div>
            <h4>Peso (g)</h4>
            <p>{produtoSelecionado.peso}</p>
          </div>
        ),
      },

      quantidade: {
        label: "Quantidade",
        type: "number",
        // space: 5,
        value: 1,
      },
    },
    submit: {
      label: "Adicionar ao carrinho",
      action: adicionarProdutoCarrinho,
    },
    close: {
      label: "fechar",
      action: () => {
        setProdutoSelecionado({});
      },
    },
  };

  return (
    <div>
      <Form formData={fSelecaoEscola} />

      {escola.id && (
        <>
          
          {carregando ? (
            <CircularProgress />
          ) : produtoSelecionado.id ? (
            <Form formData={fProdutoSelecionado} />
          ) : (
            <>
              <Form formData={fFiltro} />
              <Grid container direction="row" justifyContent="center" alignItems="center">
                {catalogo.map((produto, key) => (
                  <Grid md={4} sm={12} key={key} style={{ width: "100%" }}>
                    <Card style={{ margin: "15px" }}>
                      <CardActionArea onClick={() => setProdutoSelecionado(produto)}>
                        <CardMedia
                          className={classes.media}
                          image={
                            produto.imagemPrincipal
                              ? `${serverHost()}/${produto.imagemPrincipal}`
                              : ""
                          }
                          title="Contemplative Reptile"
                        />
                        <CardContent>
                          <h5 style={{ fontWeight: "bolder" }}>{produto.nome}</h5>
                          <br />
                          <h6>R$ {produto.valorVenda / 100}</h6>
                        </CardContent>
                      </CardActionArea>
                    </Card>
                  </Grid>
                ))}
              </Grid>
            </>
          )}
        </>
      )}
    </div>
  );
}

const useStyles = makeStyles({
  root: {
    maxWidth: 345,
  },
  media: {
    height: 300,
    backgroundSize: "contain",
  },
  price: {
    fontWeight: "bolder",
  },
});